<template>
	<v-card>
		<v-card-title>
			<h3>Konkursy</h3>
		</v-card-title>
		<BidderContestList/>
	</v-card>
</template>

<script>
	import BidderContestList from "./BidderContestList";

	export default {
		name: "BidderContestView",
		components: {BidderContestList}
	};
</script>

<style scoped>

</style>
